import getClient from './getClient'

export default function signOut() {
  return getClient().auth.signOut()
}
